export default __webpack_public_path__ + "static/cafe_36018-d9ac2c586898a43b3633bd53a5320f38.png";